import * as React from 'react';
import { Container, Row, Col } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen } from '@fortawesome/free-solid-svg-icons';
import { stat } from 'fs';
import 'react-notifications-component/dist/theme.css';
import ReadingList from "./readingList";
import ReadingDetail from "./readingDetail";
import { Capitalize, showAlert } from '../common/functions';

class ReadingsPageComponent extends React.Component {
	state = {
		isView: false,
		selectedId: false,
		dropdownShopOpen: false,
		page: "",
		id: -1,
		bibleId: -1,
		title: ""
	}
	constructor(props: any) {
		super(props);
		var tokenstr = (new URLSearchParams(window.location.search)).get("page");
		let tValue = tokenstr === null ? "" : tokenstr
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var id = idstr === null ? -1 : parseInt(idstr);
		var bibleIdstr = localStorage.getItem("bibleId");
		var bibleId = bibleIdstr === null ? -1 : parseInt(bibleIdstr);

		this.state = {
			isView: false,
			selectedId: false,
			dropdownShopOpen: false,
			page: tValue,
			id: id,
			bibleId: bibleId,
			title: ""
		}
		this.handleCallbackMethod = this.handleCallbackMethod.bind(this);
	}

	componentDidMount() {
		var tokenstr = (new URLSearchParams(window.location.search)).get("page");
		let tValue = tokenstr === null ? "" : tokenstr
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var id = idstr === null ? -1 : parseInt(idstr);
		var pageValue = id === -1 ? tValue : "detail";
		this.setState({
			...stat,
			page: pageValue,
			id: id,
			isView: pageValue === "" ? true : false
		});
		var alertMessage = window.localStorage.getItem('alertMessage');
		if (alertMessage && alertMessage !== "") {
			showAlert(alertMessage, false);
			window.localStorage.setItem('alertMessage', "");
		}

		document.title = `${pageValue==="" ? "Readings" : "Reading"} - Daily Audio Bible Administration`;
	}

	handleCallbackMethod(value) {
		this.setState({ title: value });
	}

	render() {
		const { title } = this.state;
		return (
			<Container>
				<Row>
					<Col lg="12">
						{this.state.page === "add" && (
							<div>
								<h2>
									<FontAwesomeIcon icon={faBookOpen} />
									<span data-testid="readingPageTitle"> Reading - Create New</span>
								</h2>
								<hr />
								<ReadingDetail callback={this.handleCallbackMethod} id={this.state.id} />
							</div>
						)}
						{this.state.page === "detail" && (
							<div>
								<h2>
									<FontAwesomeIcon icon={faBookOpen} />
									<span data-testid="readingPageTitle"> Reading - {Capitalize(title)} Details</span>
								</h2>
								<hr />
								<ReadingDetail callback={this.handleCallbackMethod} id={this.state.id} />
							</div>
						)}
						{this.state.page === "" && this.state.isView && (
							<div>
								<h2>
									<FontAwesomeIcon icon={faBookOpen} />
									<span data-testid="readingPageTitle"> Readings</span>
								</h2>
								<hr />
								<ReadingList bibleIdFromQuery={this.state.bibleId} />
							</div>
						)}
					</Col>
				</Row>
			</Container>
		);
	}
}
export default ReadingsPageComponent;